export const firebaseErrors: any = {
  "auth/user-not-found": "Es existiert kein Nutzer mit dieser E-Mail Adresse.",
  "auth/email-already-in-use":
    "Es existiert bereits ein Account mit dieser E-Mail Adresse.",
  "auth/invalid-email": "Ungültige E-Mail Adresse.",
  "auth/wrong-password": "Das eingegebene Passwort ist falsch.",
  "auth/weak-password": "Das eingegebene Passwort ist nicht stark genug."
};
